// Boosting Collection Pages Sort Order Code Starts
var realPage = 1;
var clickedPage = 1;
var lastProductId = null;
var boostingDone = false;
var wizzyCollectionProductIds2 = [];
var wizzyCachedFilters = null;
var receivedProductIds = [];
const WIZZY_REAL_PAGE_KEY = "wizzy_realPage";
const WIZZY_CLICKED_PAGE_KEY = "wizzy_clickedPage";
const WIZZY_LAST_PRODUCT_ID = "wizzy_lastProductId";
const WIZZY_COLLECTION_HANDLE = "wizzy_collectionHandle";
const WIZZY_RECEIVED_PRODUCT_IDS = "wizzy_receivedProductIds";
// Boosting Collection Pages Sort Order Code Ends
try {
    
window.onWizzyScriptLoaded = function () {
    const targetNode = document.querySelector(".wizzy-body-end-wrapper");
  function updateBodyClass() {
      const autocompleteElement = targetNode.querySelector(".wizzy-autocomplete-wrapper");
      autocompleteElement && window.getComputedStyle(autocompleteElement).display === "flex" ? document.body.classList.add("wizzy-autocomplete-open") : document.body.classList.remove("wizzy-autocomplete-open")
      if(autocompleteElement)
      {
        const input = document.querySelector(
            '.header__row-segment-desktop .search-wrapper .quick-search__input'
        );
        // const autocomplete = document.querySelector('.wizzy-autocomplete-wrapper');

        if (input)
        {
            const inputRect = input.getBoundingClientRect();
            const viewportWidth = window.innerWidth;

            const rightOffset = viewportWidth - inputRect.right;
            

            autocompleteElement.style.right = `${rightOffset}px`;
            autocompleteElement.style.left = 'auto'; // important
        }
      }
  }
  const config = {
      childList: !0,
      subtree: !0,
      attributes: !0,
      attributeFilter: ["style"]
  }
    , callback = function(mutationsList, observer2) {
      for (const mutation of mutationsList) {
          updateBodyClass();
          break
      }
  }
    , observer = new MutationObserver(callback);
  targetNode && (observer.observe(targetNode, config),
  updateBodyClass());
    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (data) {
        data.filters.configs.keepOpenedInMobileAfterApply = true;
        wizzyConfig.search.view.templates.facets.rangeListItem = '#wizzy-facet-range-list-item';
        data.filters.configs.layout = 'v1';
        data.search.configs.facets.leftFacets.mobileCollapsible = true;
        // data.search.configs.pagination.type = "infinite_scroll";
        if(window.wizzyConfig.common.isOnCategoryPage)
        {
            // window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = [
            //     "body main"
            // ];
        }
        else
        {
            window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = [
                "body main"
            ]
        }
        
        if(window.innerWidth > 768)
        {
            window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [
                {
                    dom :  ".header__row-segment-desktop .search-wrapper .quick-search__input",
                    type : "text"
                }
            ];
        }
        else
        {
            window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [
                {
                    dom :  ".header__row-mobile .search-wrapper .quick-search__input",
                    type : "text"
                }
            ];
        }
        return data;
    });
    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (data) {
        if(data?.facets)
        {
          console.log("facets", data.facets);
          data.facets.forEach((facet) => {
            if(facet.key === "discountPercentage")
            {
                console.log("Inside if");
              facet.config = {
                interval: 10
              }
            }
          })
        }
        document.body.classList.remove('header-transparent');
        document.body.classList.add('wizzy-search');
        document.body.classList.remove('wizzy-collection');
        let header_ele = document.querySelector('header.header');
        if(header_ele)
        {
            header_ele.classList.remove('header--transparent');
        }
        
        // console.log("BEFORE_SEARCH_EXECUTED", data);
        const alreadyExists2 = data.sort.some(
            (s) => s.field === "sellingPrice" && s.order === "asc"
        );
        if (!alreadyExists2 && data.sort[0].field === "relevance") {
            data.sort.push({ field: "sellingPrice", order: "asc", isForParent: !1});
        }
        const alreadyExists1 = data.sort.some(
            (s) => s.field === "product_wizzy-best-selling_sortOrder:float" && s.order === "asc"
        );
        if (!alreadyExists1 && data.sort[0].field === "relevance") {
            data.sort.push({ field: "product_wizzy-best-selling_sortOrder:float", order: "asc"});
        }
        return data;
    });

    const colorMap = new Map([
        ["Abby Stone", ["#aba798", !1]],
        ["Beige", ["#c6b39d", !1]],
        ["Black", ["#232323", !1]],
        ["Blue Mist", ["#acb9c9", !1]],
        ["Blush Pink", ["#e8b3d1", !1]],
        ["Bone", ["#cdc6bd", !1]],
        ["Camel", ["#b8ac92", !1]],
        ["Charcoal", ["#474748", !1]],
        ["Coffee", ["#3c352f", !1]],
        ["Cornflower Blue", ["#6b9cd1", !1]],
        ["Dark Burgundy", ["#523135", !1]],
        ["Dark Cocoa", ["#403332", !1]],
        ["Dark Navy", ["#292d3e", !1]],
        ["Deep Green", ["#445148", !1]],
        ["Deep Teal", ["#19464b", !1]],
        ["Dusty Pink", ["#c0a09d", !1]],
        ["Ecru", ["#ede2d5", !1]],
        ["Eggnog", ["#ede1d3", !1]],
        ["Fresh Mint", ["#b3cbb9", !1]],
        ["Dark Grey Marl", ["#48474d", !1]],
        ["Grey Marl", ["#c0c5ce", !1]],
        ["Ivory", ["#e0dfd7", !1]],
        ["Khaki Green", ["#535145", !1]],
        ["Lilac Thistle", ["#b8b3c5", !1]],
        ["Light Beige", ["#decec0", !1]],
        ["Navy", ["#223a5d", !1]],
        ["Navy Pewter", ["#40404d", !1]],
        ["Oatmeal Heather", ["#d3c1b7", !1]],
        ["Dark Olive", ["#5e5246", !1]],
        ["Pebble Grey", ["#7a7a72", !1]],
        ["Sage Green", ["#88857f", !1]],
        ["Silver Grey", ["#66686c", !1]],
        ["Silver Mink", ["#8b8381", !1]],
        ["Stone", ["#e1dfd7", !1]],
        ["Taupe", ["#736265", !1]],
        ["Tawny Rust", ["#715151", !1]],
        ["Vintage Khaki", ["#9e9a94", !1]],
        ["Vivid Red", ["#bd3236", !1]],
        ["Walnut", ["#796b5f", !1]],
        ["White", ["#ffffff", !1]],
        ["Dark Khaki", ["#585c52", !1]]
    ]);



    function findHaxCode(key) {
        return colorMap.has(key) ? colorMap.get(key) : [key, !1];
    }


  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
    function (payload) {
    //   console.log("before render results 1", payload);
      if(payload?.response?.payload?.facets && window.innerWidth < 768)
      {
        let facets = payload.response.payload.facets;
        if(facets)
        {
            facets.forEach((facet) => {
                facet.position = 'left';
            })
        }
      }
      if (payload.api === "search" || payload.api === "filter") {
        var facets = payload.response.payload.facets;
        // console.log(facets);
        
        if(facets)
        {
            for (let i = 0; i < facets.length; i++) {
                if (facets[i].key == "sizes") {
                    let sizes = facets[i].data,
                        numbers = [],
                        letters = [],
                        newArray = new Array(),
                        temp = [
                        "XS","S","S-M","M","M-L","L","XL","XXL","28","30","32","34","36","38","40","5-6YRS","6-7 YRS","7-8YRS","O/S","One Size","Regular"
                        ];
                    for (let j = 0; j < temp.length; j++) {
                        for (let k = 0; k < sizes.length; k++) {
                        sizes[k].key == temp[j] && newArray.push(sizes[k]);
                        }
                    }
                    facets[i].data = newArray;
                }
            }
          // console.log("inside facets condition");
          facets.forEach((facet) => {
            if(facet.key === "product_Color")
            {
              // console.log("inside colors");
              facet.data.forEach((item) => {
                // console.log("inside loop");
                // console.log(item.key);
                let color = findHaxCode(item.key) || ["#e5e5e5", !1];
                // console.log(color);
                // console.log("inside loop 1");
                (item.isSwatch = !0),
                  (item.isURLSwatch = color[1]),
                  (item.isVisualSwatch = !0),
                  (item.swatchValue = color[0]),
                  (item.data = {
                    value: item.key,
                    swatch: {
                      type: "visual",
                      value: color[0],
                    },
                  });
              });
            }
          });
        }
        // console.log(payload);
      }
      // console.log("before render results 2");

      return payload;
    }
  );

    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (data) {
        if (data?.filters?.facets) {
            console.log("facets", data.filters.facets);

            const facets = Array.isArray(data.filters.facets)
                ? data.filters.facets
                : Object.values(data.filters.facets);

            facets.forEach((facet) => {
                if (facet.key === "discountPercentage") {
                facet.config = {
                    interval: 10,
                };
                }
            });
        }
        if(window.wizzyConfig.common.isOnCategoryPage){
            data.filters.inStock = ["true","false"];
            data.filters.showOOSProductsInOrder = "true";
            // data.filters.boostGroupIds = [];
        }

        
        
        // const alreadyExists2 = data.filters.sort.some(
        //     (s) => s.field === "sellingPrice" && s.order === "asc"
        // );
        // if (!alreadyExists2 && data.filters.sort[0].field === "relevance") {
        //     data.filters.sort.push({ field: "sellingPrice", order: "asc", isForParent: !1});
        // }
        // const alreadyExists1 = data.filters.sort.some(
        //     (s) => s.field === "product_wizzy-best-selling_sortOrder:float" && s.order === "asc"
        // );
        // if (!alreadyExists1 && data.filters.sort[0].field === "relevance") {
        //     data.filters.sort.push({ field: "product_wizzy-best-selling_sortOrder:float", order: "asc"});
        // }
        return data;
    },3);
    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (products) {
        products.forEach((product) => {
            let attributes = product.attributes;
            if(attributes)
            {
                attributes.forEach((attr) => {
                    if(attr.id === "product_variant_prices")
                    {
                        let min_price = attr.values[0].value[0];
                        let first_price = attr.values[0].value[0];
                        let values = attr.values;
                        let same_price = 1;
                        values.forEach((val) => {
                            let cur_val = val.value[0];
                            if(cur_val < min_price)
                            {
                                min_price = cur_val;
                            }
                            if(first_price != cur_val)
                            {
                                same_price = 0;
                            }
                        })
                        product.min_price = min_price;
                        product.min_priceMul = product.min_price * 100;
                        product.IsSamePrices = same_price;
                    }
                    else if(attr.id === "product_product_page_collection_custom")
                    {
                        product.collection_subtitle = attr.values[0].value[0];
                    }
                    else if (attr.id === "product_tags") {
                        const tags = attr.values?.[0]?.value?.[0]
                            ?.split(",")
                            .map(tag => tag.trim().toLowerCase()) || [];

                        product.hasTag = ["new", "trending", "best seller"].find(tag =>
                            tags.includes(tag)
                        );
                    }
                })
            }
            if(!product.inStock) {
              const url = new URL(product.url);
               url.searchParams.delete("variant"),
              product.url = url.toString();
            }
            product.sellingPriceMul = product.sellingPrice * 100;
            product.priceMul = product.price * 100;
        })
        return products;
    });
    // document.addEventListener('click', function(e) {
    //     console.log(e.target.classList);
    //     if(e.target.classList.contains('wizzy-filters-desktop-entry'))
    //     {
    //         let filter_body = document.querySelector('.wizzy-facet-head.active');
    //         if(filter_body)
    //         {
    //             filter_body.click();
    //         }
    //     }
    // })
   document.addEventListener('mouseover', function(e) {
        const el = e.target.closest('.product-item__image--two');
        if (el) el.classList.add('active');
    });

    document.addEventListener('mouseout', function(e) {
        const el = e.target.closest('.product-item__image--two');
        if (el) el.classList.remove('active');
    });

    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
    function (data) {
        data.filters.configs.keepOpenedInMobileAfterApply = true;
        wizzyConfig.search.view.templates.facets.rangeListItem = '#wizzy-facet-range-list-item';
        data.filters.configs.layout = 'v1';
        data.search.configs.facets.leftFacets.mobileCollapsible = true;
        // data.search.configs.pagination.type = "infinite_scroll";
        if(window.wizzyConfig.common.isOnCategoryPage)
        {
            // window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = [
            //     "body main"
            // ];
        }
        else
        {
            window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = [
                "body main"
            ]
        }
        
        if(window.innerWidth > 768)
        {
            window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [
                {
                    dom :  ".header__row-segment-desktop .search-wrapper .quick-search__input",
                    type : "text"
                }
            ];
        }
        else
        {
            window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [
                {
                    dom :  ".header__row-mobile .search-wrapper .quick-search__input",
                    type : "text"
                }
            ];
        }
        
        return data;
    });
    // function updateFacetSelectedValues() {
    //     // STEP 1 — Read selected filters
    //     const selectedItems = document.querySelectorAll(".wizzy-selected-facet-list li");
    //     const selectedMap = {};

    //     selectedItems.forEach(li => {
    //         const key = li.getAttribute("data-facetkey");
    //         const value = li.getAttribute("title")?.trim(); // value stored in title

    //         if (!key || !value) return;

    //         if (!selectedMap[key]) {
    //             selectedMap[key] = [];
    //         }
    //         selectedMap[key].push(value);
    //     });

    //     // STEP 2 — Update each facet block
    //     document.querySelectorAll(".wizzy-search-filters-left-wrapper .wizzy-filters-facet-block").forEach(block => {
    //         const facetKey = block.getAttribute("data-key");
    //         if (!facetKey) return;

    //         // Create UI placeholder if missing
    //         let displayDiv = block.querySelector(".facet-selected-values");
    //         if (!displayDiv) {
    //             displayDiv = document.createElement("div");
    //             displayDiv.className = "facet-selected-values";

    //             const head = block.querySelector(".wizzy-facet-head");
    //             const body = block.querySelector(".wizzy-facet-body");

    //             if (head && body) head.insertAdjacentElement("afterend", displayDiv);
    //         }

    //         let values = selectedMap[facetKey];

    //         // SPECIAL CASE — sellingPrice
    //         if (facetKey === "sellingPrice" && (!values || values.length === 0)) {
                
    //             // Find slider inside this block
    //             const slider = block.querySelector(".wizzy-facet-range-slider");

    //             if (slider) {
    //                 const min = slider.getAttribute("data-min");
    //                 const max = slider.getAttribute("data-max");

    //                 if (min && max) {
    //                     displayDiv.innerText = `₹${min} - ₹${max}`;
    //                 } else {
    //                     displayDiv.innerText = "All";
    //                 }
    //             } else {
    //                 displayDiv.innerText = "All";
    //             }

    //             return; // done for price facet
    //         }

    //         // NORMAL FACETS
    //         if (values && values.length > 0) {
    //             displayDiv.innerText = values.join(", ");
    //         } else {
    //             displayDiv.innerText = "All";
    //         }
    //     });
    // }
    document.addEventListener("click", function (e) {
        const facetHead = e.target.closest(".wizzy-facet-head");
        if (!facetHead) return;

        const valuesWrapper = document.querySelector(
            ".filters-list-top-values-wrapper"
        );
        const searchWrapper = document.querySelector(".wizzy-search-wrapper");
        if (!valuesWrapper || !searchWrapper) return;

        const headRect = facetHead.getBoundingClientRect();
        const wrapperRect = searchWrapper.getBoundingClientRect();

        const style = getComputedStyle(searchWrapper);
        const paddingLeft = parseFloat(style.paddingLeft) || 0;

        // FINAL left position (relative to content area)
        const leftPos =
            headRect.left -
            wrapperRect.left -
            paddingLeft;

        valuesWrapper.style.left = `${leftPos}px`;
        valuesWrapper.classList.add("active");
        });


    // function initFiltersTopDrawer() {
    //     const trigger = document.querySelector('.wizzy-search-filters-drawer');
    //     const drawer = document.querySelector('.wizzy-search-filters-list-top');

    //     if (!trigger || !drawer) return;

    //     trigger.addEventListener('click', function () {
    //         drawer.classList.toggle('is-open');
    //         trigger.classList.toggle('is-open');
    //     });
    // }
    function initFiltersTopDrawer() {
        const trigger = document.querySelector('.wizzy-search-filters-drawer');
        const drawer = document.querySelector('.wizzy-search-filters-list-top');
        const selectedFilters = document.querySelector('.wizzy-selected-filters .wizzy-selected-facet-list');

        if (!trigger || !drawer) return;

        function hasSelectedFilters() {
            return selectedFilters && selectedFilters.children.length > 0;
        }

        if (hasSelectedFilters()) {
            drawer.classList.add('is-open');
            trigger.classList.add('is-open');
        }

        if (!trigger.dataset.listenerAdded) {
            trigger.dataset.listenerAdded = "true";
            trigger.addEventListener('click', function () {
                // // If trying to close while filters exist → block
                // if (drawer.classList.contains('is-open') && hasSelectedFilters()) {
                //     return;
                // }

                drawer.classList.toggle('is-open');
                trigger.classList.toggle('is-open');
            });
        }
    }

    function updateFacetSelectedValues() {
        // STEP 1 — Read selected filters
        const selectedItems = document.querySelectorAll(".wizzy-selected-facet-list li");
        const selectedMap = {};

        selectedItems.forEach(li => {
            const key = li.getAttribute("data-facetkey");
            const value = li.getAttribute("title")?.trim();

            if (!key || !value) return;

            if (!selectedMap[key]) {
                selectedMap[key] = new Set(); // prevent duplicates
            }
            selectedMap[key].add(value);
        });
        // 👇 ADD HERE
        let filterCount = 0;
        Object.values(selectedMap).forEach(valueSet => {
            if (valueSet && valueSet.size) {
                filterCount += valueSet.size;
            }
        });
        // window.wizzySelectedFilterCount = filterCount;
        let total_filter_count = document.querySelector('.filter-drawer__title-count');
        if(total_filter_count)
        {
            total_filter_count.textContent = filterCount;
        }
        // STEP 2 — Update each facet block
        document
            .querySelectorAll(".wizzy-search-filters-left-wrapper .wizzy-filters-facet-block")
            .forEach(block => {

                const facetKey = block.getAttribute("data-key");
                if (!facetKey) return;

                const valuesSet = selectedMap[facetKey];
                const selectedCount = valuesSet ? valuesSet.size : 0;

                // ---------- HANDLE SELECTED VALUES UI ----------
                let displayDiv = block.querySelector(".facet-selected-values");

                if (!valuesSet || valuesSet.size === 0) {
                    // remove selected values display
                    if (displayDiv) displayDiv.remove();
                } else {
                    // create only when needed
                    if (!displayDiv) {
                        displayDiv = document.createElement("div");
                        displayDiv.className = "facet-selected-values";

                        const head = block.querySelector(".wizzy-facet-head");
                        if (head) {
                            head.insertAdjacentElement("afterend", displayDiv);
                        }
                    }

                    displayDiv.innerText = Array.from(valuesSet).join(", ");
                }

                // ---------- HANDLE COUNT IN FACET TITLE ----------
                const titleEl = block.querySelector(".facet-head-title");
                if (!titleEl) return;

                let countSpan = titleEl.querySelector(".facet-selected-count");

                if (selectedCount > 0) {
                    // create count span if missing
                    if (!countSpan) {
                        countSpan = document.createElement("span");
                        countSpan.className = "facet-selected-count";
                        titleEl.appendChild(countSpan);
                    }

                    countSpan.innerText = ` ${selectedCount}`;
                } else {
                    // remove count when nothing selected
                    if (countSpan) {
                        countSpan.remove();
                    }
                }
            });
    }
    function getSelectedFacetValuesByKey(key) {
        const selectedList = document.querySelector('.wizzy-selected-facet-list');
        if (!selectedList) return [];

        return Array.from(
            selectedList.querySelectorAll(
                `.wizzy-selected-facet-list-item[data-facetkey="${key}"]`
            )
        );
    }
    function getFacetOnlyValue(item) {
        const valueEl = item.querySelector('.facet-item-label-value');
        if (!valueEl) return '';

        const clone = valueEl.cloneNode(true);
        clone.querySelector('.facet-item-label-value-id')?.remove();

        return clone.textContent.trim();
    }
    function initDesktopFacetTopSummary() {
        document.addEventListener('click', function (e) {
            const facetHead = e.target.closest('.wizzy-facet-head');
            if (!facetHead) return;

            const facetBlock = facetHead.closest('.wizzy-filters-facet-block');
            if (!facetBlock) return;

            const facetKey = facetBlock.getAttribute('data-key');
            if (!facetKey) return;

            const selectedItems = getSelectedFacetValuesByKey(facetKey);

            const wrapper = document.querySelector('.filters-list-top-values-wrapper');
            if (!wrapper) return;
            // console.log("c1");
            // Avoid duplicate summary
            if (wrapper.querySelector(`.facet-selected-summary[data-key="${facetKey}"]`)) {
                return;
            }
            // console.log("c2");
            let valuesText = '0 selected';
            // console.log("selectedItems", selectedItems);
            if (selectedItems.length) {
                const values = selectedItems
                    .map(item => getFacetOnlyValue(item))
                    .filter(Boolean);

                if (values.length) {
                    valuesText = values.join(', ');
                }
            }

            const summary = document.createElement('div');
            summary.className = 'facet-selected-summary';
            summary.setAttribute('data-key', facetKey);

            summary.innerHTML = `
                <span class="facet-selected-summary-values">
                    ${valuesText}
                </span>
                ${
                    selectedItems.length
                        ? `<button type="button" class="facet-selected-summary-clear">Clear</button>`
                        : ''
                }
            `;

            const facetList = wrapper.querySelector('.wizzy-facet-list');
            if (!facetList || !facetList.parentNode) return;

            facetList.parentNode.insertBefore(summary, facetList);

        });
    }

    document.addEventListener('click', function (e) {
        const clearBtn = e.target.closest('.facet-selected-summary-clear');
        if (!clearBtn) return;

        const summary = clearBtn.closest('.facet-selected-summary');
        if (!summary) return;

        const key = summary.getAttribute('data-key');
        if (!key) return;

        const items = getSelectedFacetValuesByKey(key);

        items.forEach(item => {
            const del = item.querySelector('.wizzy-selected-facet-delete');
            del && del.click();
        });

        summary.remove();
    });

    
    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_FILTER_ITEM_CLICKED,
    function (data) {
        // console.log("AFTER_FILTER_ITEM_CLICKED", data);
        
        window.selectedFacetKey = data.facetKey;
        return data;
    });
    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
        // console.log(data);
        
        let count = data?.data?.response?.payload?.total;
        if(count)
        {
            window.localStorage.setItem("wz_count", count);
            let result_count = document.querySelector('.wizzy-search-wrapper .filter-bar__results-count');
            if(result_count)
            {
                result_count.innerText = `${count} Results`;
            }
        }
        try {
            
        
        if(window.wizzyConfig.common.isOnCategoryPage)
        {
            document.body.classList.remove('wizzy-search');
            document.body.classList.add('wizzy-collection');
        }
        else
        {
            document.body.classList.add('wizzy-search');
            document.body.classList.remove('wizzy-collection');
        }
        
        updateFacetSelectedValues();

        initFiltersTopDrawer();
        initDesktopFacetTopSummary();
        const productCountMessage = document.querySelector(".wizzy-search-pagination .product-progress-container #product-count-message");
        if (
        productCountMessage &&
        data?.data?.response?.payload
        ) {
            const {
                filters,
                result,
                total
            } = data.data.response.payload;

            const currentPage = filters.page;
            const pageSize = filters.productsCount;

            // START index
            const start =
                (currentPage - 1) * pageSize + 1;

            // END index (handle last page safely)
            const end =
                Math.min(
                start + result.length - 1,
                total
                );

            const countMessage = `You are viewing ${start}-${end} of ${total} products`;
            productCountMessage.innerHTML = countMessage;
        }
        if (window.selectedFacetKey && window.innerWidth > 768) {
            const facetHead = document.querySelector(
                `.wizzy-filters-facet-block[data-key="${window.selectedFacetKey}"] .wizzy-facet-head`
            );
            let selectedFacets = document.querySelectorAll('.wizzy-selected-facet-list li');

            if (facetHead && selectedFacets && selectedFacets.length > 0) {
                facetHead.click();
            }

            window.selectedFacetKey = undefined;
        }
        let filter_apply = document.querySelector('.wizzy-apply-all-button');
        if(filter_apply && !filter_apply.dataset.listenerAdded)
        {
            filter_apply.dataset.listenerAdded = "true";
            filter_apply.addEventListener('click', function(){
                let filter_btn = document.querySelector('.wizzy-filters-close-btn');
                if(filter_btn)
                {
                    filter_btn.click();
                }
            })
        }
        let filter_close = document.querySelector('.filter-drawer__close.filter-close');
        if(filter_close && !filter_close.dataset.listenerAdded)
        {
            filter_close.dataset.listenerAdded = "true";
            filter_close.addEventListener('click', function(){
                let filter_btn = document.querySelector('.wizzy-filters-close-btn');
                if(filter_btn)
                {
                    filter_btn.click();
                }
            });
        }
        let sort_close = document.querySelector('.filter-drawer__close.sort-close');
        if(sort_close && !sort_close.dataset.listenerAdded)
        {
            sort_close.dataset.listenerAdded = "true";
            sort_close.addEventListener('click', function(){
                let sort_btn = document.querySelector('.wizzy-common-select-selector');
                if(sort_btn)
                {
                    sort_btn.click();
                }
            })
        }

        let sort_done = document.querySelector('.wizzy-search-wrapper .filter-drawer__footer-buttons .filter-drawer__button-apply');
        if(sort_done && !sort_done.dataset.listenerAdded)
        {
            sort_done.dataset.listenerAdded = "true";
            sort_done.addEventListener('click', function(){
                let sort_btn = document.querySelector('.wizzy-common-select-selector');
                if(sort_btn)
                {
                    sort_btn.click();
                }
            })
        }
        let filter_button = document.querySelector('.wizzy-search-filters-drawer-button');
        if(filter_button && !filter_button.dataset.listenerAdded)
        {
            filter_button.dataset.listenerAdded = "true";
            filter_button.addEventListener('click', function(){
                let facet_head = document.querySelector('.wizzy-facet-head.active');
                if(facet_head)
                {
                    facet_head.click();
                }
            })
        }
        } catch (error) {
            console.log(error);
        }
        return data;
    });
    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (data) {
        document.body.classList.add('wizzy-search-results-rendered');
        console.log(data);
        // let count = data?.data?.response?.payload?.total;
        let count = window.localStorage.getItem("wz_count");
        if(count)
        {
            let result_count = document.querySelector('.wizzy-search-wrapper .filter-bar__results-count');
            if(result_count)
            {
                result_count.innerText = `${count} Results`;
            }
        }
        updateFacetSelectedValues();

        initFiltersTopDrawer();
        initDesktopFacetTopSummary();

        if(window.wizzyConfig.common.isOnCategoryPage)
        {
            document.body.classList.remove('wizzy-search');
            document.body.classList.add('wizzy-collection');
        }
        else
        {
            document.body.classList.add('wizzy-search');
            document.body.classList.remove('wizzy-collection');
        }
        const productCountMessage = document.querySelector(".wizzy-search-pagination .product-progress-container #product-count-message");
        if (
        productCountMessage &&
        data?.data?.response?.payload
        ) {
            const {
                filters,
                result,
                total
            } = data.data.response.payload;

            const currentPage = filters.page;
            const pageSize = filters.productsCount;

            // START index
            const start =
                (currentPage - 1) * pageSize + 1;

            // END index (handle last page safely)
            const end =
                Math.min(
                start + result.length - 1,
                total
                );

            const countMessage = `You are viewing ${start}-${end} of ${total} products`;
            productCountMessage.innerHTML = countMessage;
        }

        let filter_apply = document.querySelector('.wizzy-apply-all-button');
        if(filter_apply && !filter_apply.dataset.listenerAdded)
        {
            filter_apply.dataset.listenerAdded = "true";
            filter_apply.addEventListener('click', function(){
                let filter_btn = document.querySelector('.wizzy-filters-close-btn');
                if(filter_btn)
                {
                    filter_btn.click();
                }
            })
        }
        let filter_close = document.querySelector('.filter-drawer__close.filter-close');
        if(filter_close && !filter_close.dataset.listenerAdded)
        {
            filter_close.dataset.listenerAdded = "true";
            filter_close.addEventListener('click', function(){
                let filter_btn = document.querySelector('.wizzy-filters-close-btn');
                if(filter_btn)
                {
                    filter_btn.click();
                }
            });
        }
        let sort_close = document.querySelector('.filter-drawer__close.sort-close');
        if(sort_close && !sort_close.dataset.listenerAdded)
        {
            sort_close.dataset.listenerAdded = "true";
            sort_close.addEventListener('click', function(){
                let sort_btn = document.querySelector('.wizzy-common-select-selector');
                if(sort_btn)
                {
                    sort_btn.click();
                }
            })
        }

        let sort_done = document.querySelector('.wizzy-search-wrapper .filter-drawer__footer-buttons .filter-drawer__button-apply');
        if(sort_done && !sort_done.dataset.listenerAdded)
        {
            sort_done.dataset.listenerAdded = "true";
            sort_done.addEventListener('click', function(){
                let sort_btn = document.querySelector('.wizzy-common-select-selector');
                if(sort_btn)
                {
                    sort_btn.click();
                }
            })
        }
        let filter_button = document.querySelector('.wizzy-search-filters-drawer-button');
        if(filter_button && !filter_button.dataset.listenerAdded)
        {
            filter_button.dataset.listenerAdded = "true";
            filter_button.addEventListener('click', function(){
                let facet_head = document.querySelector('.wizzy-facet-head.active');
                if(facet_head)
                {
                    facet_head.click();
                }
            })
        }
        return data;
    });

    // Boosting Collection Pages Sort Order Code Starts
   try {
      window.wizzyConfig.events.registerEvent(
         window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
         function (payload) {
            var tempPage = window.wizzyConfig?.pageStore?.searchedResponse?.filters?.page;
            var tempRealPage;

            if (tempPage &&
               clickedPage > 1 &&
               payload.response?.payload?.filters?.sort &&
               payload.response.payload.filters.sort.length &&
               payload.response.payload.filters.sort[0].field == "relevance" &&
               window.wizzyConfig.common.isOnCategoryPage === true) {
               tempRealPage = clickedPage;
               payload.response.payload.filters.page = tempRealPage;
               payload.response.payload.filters.productsCount = window.wizzyConfig?.search?.configs?.general?.noOfProducts ?? 18;

               var results = payload.response?.payload?.result;

               if (results && results.length > 0) {
                  var lastProduct = results.at(-1);
                  var lastId = lastProduct?.groupId || lastProduct?.id || null;
                  if (lastId) lastProductId = parseInt(lastId);
                  if (lastProductId) {
                     if (lastProductId === wizzyCollectionProductIds2[wizzyCollectionProductIds2.length - 1]) {
                        boostingDone = true;
                     } else if (lastProductId != wizzyCollectionProductIds2[wizzyCollectionProductIds2.length - 1]) {
                        boostingDone = false;
                     }
                     setSessionNumber(WIZZY_LAST_PRODUCT_ID, lastProductId);
                  }
               }
            }

            if (payload.response?.payload?.filters?.sort &&
               payload.response.payload.filters.sort.length &&
               payload.response.payload.filters.sort[0].field == "relevance" &&
               window.wizzyConfig.common.isOnCategoryPage === true) {
               var results = payload.response?.payload?.result;
               var hasAttributes = payload.response.payload.filters.attributes && Object.values(payload.response.payload.filters.attributes).some(v => Array.isArray(v) && v.length > 0);
               var hasFloatAttributes = payload.response.payload.filters.floatAttributes && Object.values(payload.response.payload.filters.floatAttributes).some(v => Array.isArray(v) && v.length > 0);
               var hasBrands = payload.response.payload.filters.brands && payload.response.payload.filters.brands.length > 0;
               var hasSellingPrice = payload.response.payload.filters.sellingPrice && payload.response.payload.filters.sellingPrice.length > 0;
               var hasGenders = payload.response.payload.filters.genders && payload.response.payload.filters.genders.length > 0;
               var hasSizes = payload.response.payload.filters.sizes && payload.response.payload.filters.sizes.length > 0;
               var hasAnyOtherFilterApplied = hasAttributes || hasBrands || hasSellingPrice || hasGenders || hasFloatAttributes || hasSizes;
               if (results && results.length > 0 && !hasAnyOtherFilterApplied) {
                  var pCount = window.wizzyConfig?.search?.configs?.general?.noOfProducts ?? 18;
                  var tPCount = payload.response?.payload?.total ?? 0;
                  var tPages = Math.ceil(tPCount / pCount);
                  if (tempRealPage === tPages) {
                     for (var i = results.length - 1; i >= 0; i--) {
                        var product = results[i];
                        var id = product?.groupId || product?.id || null;

                        if (!id) break;

                        var strId = String(id);

                        if (receivedProductIds.includes(strId)) {
                           results.splice(i, 1);
                        } else {
                           break;
                        }
                     }
                  }

                  results.forEach(function (product) {
                     var id = product?.groupId || product?.id || null;
                     if (id) {
                        receivedProductIds.push(String(id));
                     }
                  });
               } else {
                  receivedProductIds = [];
               }
               setSessionStringArray(WIZZY_RECEIVED_PRODUCT_IDS, receivedProductIds);
            } else {
               receivedProductIds = [];
               setSessionStringArray(WIZZY_RECEIVED_PRODUCT_IDS, receivedProductIds);
            }

            return payload;
         }
      );
   } catch (e) {
      console.log("wizzy before render", e);
   }
   // Boosting Collection Pages Sort Order Code Ends

   // Boosting Collection Pages Sort Order Code Starts
    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (data) {
        if (data?.filters?.facets) {
            console.log("facets", data.filters.facets);

            const facets = Array.isArray(data.filters.facets)
                ? data.filters.facets
                : Object.values(data.filters.facets);

            facets.forEach((facet) => {
                if (facet.key === "discountPercentage") {
                facet.config = {
                    interval: 10,
                };
                }
            });
        }
        if (window.wizzyConfig.common.isOnCategoryPage) {
            data.filters.inStock = ["true","false"];
            data.filters.showOOSProductsInOrder = "true";
            data.filters.boostGroupIds = [];
            data.filters.productsCount = window.wizzyConfig?.search?.configs?.general?.noOfProducts ?? 18;

            if (
               data.filters.sort &&
               data.filters.sort.length &&
               data.filters.sort[0].field == "relevance" &&
               window.wizzyConfig.common.isOnCategoryPage === true
            ) {
               var hasAttributes = data.filters.attributes && Object.values(data.filters.attributes).some(v => Array.isArray(v) && v.length > 0);
               var hasFloatAttributes = data.filters.floatAttributes && Object.values(data.filters.floatAttributes).some(v => Array.isArray(v) && v.length > 0);
               var hasBrands = data.filters.brands && data.filters.brands.length > 0;
               var hasSellingPrice = data.filters.sellingPrice && data.filters.sellingPrice.length > 0;
               var hasGenders = data.filters.genders && data.filters.genders.length > 0;
               var hasSizes = data.filters.sizes && data.filters.sizes.length > 0;
               var hasAnyOtherFilterApplied = hasAttributes || hasBrands || hasSellingPrice || hasGenders || hasFloatAttributes || hasSizes;
               var productsCount = window.wizzyConfig?.search?.configs?.general?.noOfProducts ?? 18;
               data.filters.productsCount = productsCount;
               var filtersChanged = hasFilterStateChanged(data.filters);
               wizzyCachedFilters = {
                  attributes: deepClone(data.filters.attributes || {}),
                  floatAttributes: deepClone(data.filters.floatAttributes || {}),
                  brands: deepClone(data.filters.brands || []),
                  sellingPrice: deepClone(data.filters.sellingPrice || []),
                  genders: deepClone(data.filters.genders || []),
                  sizes: deepClone(data.filters.sizes || []),
               };
               setCachedFilters(wizzyCachedFilters);
               if (filtersChanged) {
                  realPage = 1;
                  clickedPage = 1;
                  setSessionNumber(WIZZY_REAL_PAGE_KEY, 1);
                  setSessionNumber(WIZZY_CLICKED_PAGE_KEY, 1);
                  setSessionNumber(WIZZY_LAST_PRODUCT_ID, 0);
                  setSessionStringArray(WIZZY_RECEIVED_PRODUCT_IDS, []);
               }
               const currentCollectionHandle =
                  data.filters?.categories?.[0] ||
                  window.wizzyConfig?.common?.collectionHandle ||
                  null;
               const cachedCollectionKey = getSessionString(WIZZY_COLLECTION_HANDLE);
               if (cachedCollectionKey !== currentCollectionHandle) {
                  setSessionString(WIZZY_COLLECTION_HANDLE, currentCollectionHandle);
                  realPage = 1;
                  clickedPage = 1;
                  setSessionNumber(WIZZY_REAL_PAGE_KEY, 1);
                  setSessionNumber(WIZZY_CLICKED_PAGE_KEY, 1);
                  setSessionNumber(WIZZY_LAST_PRODUCT_ID, 0);
                  setSessionStringArray(WIZZY_RECEIVED_PRODUCT_IDS, []);
               }

               if (hasAnyOtherFilterApplied) {
                  data.filters.boostGroupIds = [];
                  // clickedPage = 1;
                  // data.filters.page = 1;
                  // setSessionNumber(WIZZY_CLICKED_PAGE_KEY, 1);
               } else {
                  var pageForIds = clickedPage || 1;
                  var categoriesHandle = data.filters?.categories?.[0] || window.wizzyConfig?.common?.collectionHandle;
                  var wizzyCollectionBoostedProductIds = getShopifyCollectionBoostIds(
                     categoriesHandle,
                     pageForIds,
                     productsCount
                  );
                  data.filters.boostGroupIds = wizzyCollectionBoostedProductIds;
                  data.filters.page = 1;
               }
               setSessionNumber(WIZZY_REAL_PAGE_KEY, realPage);
            }
         }

         if (data.filters.type === "AUTOCOMPLETE_DEFAULT") {
            delete data.filters.boostGroupIds;
            data.filters.page = 1;
         }
         data.filters.hasToReturnBanners = "false";
        return data;
    },3);
    // Boosting Collection Pages Sort Order Code Ends

     window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
      // Boosting Collection Pages Sort Order Code Starts
      if (window.wizzyConfig.common.isOnCategoryPage === true) {
         var clearallbtn = document.querySelector('.wizzy-filters-clear-all');
         if (clearallbtn) {
            clearallbtn.addEventListener('click', function () {
               realPage = 1;
               clickedPage = 1;
               setSessionNumber(WIZZY_REAL_PAGE_KEY, realPage);
               setSessionNumber(WIZZY_CLICKED_PAGE_KEY, clickedPage);
            });
         }

         var clearallbtnTop = document.querySelector('.wizzy-search-filters-top .wizzy-filters-clear-all');
         if (clearallbtnTop) {
            clearallbtnTop.addEventListener('click', function () {
               realPage = 1;
               clickedPage = 1;
               setSessionNumber(WIZZY_REAL_PAGE_KEY, realPage);
               setSessionNumber(WIZZY_CLICKED_PAGE_KEY, clickedPage);
            });
         }

         var filterItems = document.querySelectorAll('.wizzy-facet-list-item');
         if (filterItems.length > 0) {
            filterItems.forEach((filterItem) => {
               filterItem.addEventListener('click', function () {
                  realPage = 1;
                  clickedPage = 1;
                  setSessionNumber(WIZZY_REAL_PAGE_KEY, realPage);
                  setSessionNumber(WIZZY_CLICKED_PAGE_KEY, clickedPage);
               });
            });
         }

         var sortItems = document.querySelectorAll('.wizzy-common-select-option');
         if (sortItems.length > 0) {
            sortItems.forEach((sortItem) => {
               sortItem.addEventListener('click', function () {
                  realPage = 1;
                  clickedPage = 1;
                  setSessionNumber(WIZZY_REAL_PAGE_KEY, realPage);
                  setSessionNumber(WIZZY_CLICKED_PAGE_KEY, clickedPage);
               });
            });
         }
      }
      // Boosting Collection Pages Sort Order Code Ends
      return data;
    });

    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (data) {
        // Boosting Collection Pages Sort Order Code Starts
      if (window.wizzyConfig.common.isOnCategoryPage === true) {
         realPage = getSessionNumber(WIZZY_REAL_PAGE_KEY, 1);
         clickedPage = getSessionNumber(WIZZY_CLICKED_PAGE_KEY, 1);
         lastProductId = getSessionNumber(WIZZY_LAST_PRODUCT_ID, 0);
         wizzyCachedFilters = getCachedFilters();
         receivedProductIds = getSessionStringArray(WIZZY_RECEIVED_PRODUCT_IDS);
      }
      // Boosting Collection Pages Sort Order Code Ends
        return data;
    });

}
}
catch (error) {
    console.log(error);
}

// Boosting Collection Pages Sort Order Code Starts
function getActivePaginationPage() {
  var active = document.querySelector('.wizzy-pagination-list li.active[data-page]');
  if (!active) return clickedPage || 1;
  var page = parseInt(active.getAttribute('data-page'), 10);
  return isNaN(page) ? (clickedPage || 1) : page;
}

document.body.addEventListener("click", function (event) {
  if (event.target.closest(".wizzy-selected-facet-list-item")) {
    if (realPage !== 1) {
      realPage = 1;
      clickedPage = 1;
      setSessionNumber(WIZZY_REAL_PAGE_KEY, realPage);
      setSessionNumber(WIZZY_CLICKED_PAGE_KEY, clickedPage);
    }
  }

  if (event.target.closest(".wizzy-search-results-wrapper .wizzy-search-filters-left .wizzy-filters-header .wizzy-filters-clear-all")) {
    if (realPage !== 1) {
      realPage = 1;
      clickedPage = 1;
      setSessionNumber(WIZZY_REAL_PAGE_KEY, realPage);
      setSessionNumber(WIZZY_CLICKED_PAGE_KEY, clickedPage);
    }
  }

  var paginationItem = event.target.closest('.wizzy-pagination-list li');
  if (paginationItem) {
    if (paginationItem.classList.contains('previous-arrow') && !paginationItem.classList.contains('inactive')) {
      clickedPage = Math.max(1, getActivePaginationPage() - 1);
      setSessionNumber(WIZZY_CLICKED_PAGE_KEY, clickedPage);
    } else if (paginationItem.classList.contains('next-arrow') && !paginationItem.classList.contains('inactive')) {
      clickedPage = getActivePaginationPage() + 1;
      setSessionNumber(WIZZY_CLICKED_PAGE_KEY, clickedPage);
    } else if (
      !paginationItem.classList.contains('eclipse') &&
      paginationItem.getAttribute('data-page') !== '...'
    ) {
      var pageNum = parseInt(paginationItem.getAttribute('data-page'), 10);
      if (!isNaN(pageNum)) {
        clickedPage = pageNum;
        setSessionNumber(WIZZY_CLICKED_PAGE_KEY, clickedPage);
      }
    }
    var prefetchHandle = window.wizzyConfig?.common?.collectionHandle;
    var prefetchCount = window.wizzyConfig?.search?.configs?.general?.noOfProducts ?? 18;
    if (prefetchHandle) {
      prefetchShopifyCollectionBoostIds(prefetchHandle, clickedPage, prefetchCount);
    }
  }
});

var wizzyShopifyPageIdsCache = {};

function shopifyCollectionPageCacheKey(handle, page, productsCount) {
  return handle + ':' + page + ':' + productsCount;
}

function getShopifyCollectionPageIds(handle, page, productsCount) {
  if (!handle) return [];
  var key = shopifyCollectionPageCacheKey(handle, page, productsCount);
  if (wizzyShopifyPageIdsCache[key]) return wizzyShopifyPageIdsCache[key];

  // ponytail: Wizzy BEFORE_FILTERS_EXECUTED is sync, so this XHR is blocking. If Wizzy starts awaiting promises, switch to fetch().
  var url = '/collections/' + encodeURIComponent(handle) + '/products.json?limit=' + encodeURIComponent(productsCount) + '&page=' + encodeURIComponent(page);
  var xhr = new XMLHttpRequest();
  xhr.open('GET', url, false);
  xhr.send(null);
  if (xhr.status < 200 || xhr.status >= 300) return [];

  try {
    var json = JSON.parse(xhr.responseText);
    var ids = (json.products || []).map(function (product) { return product.id; });
    wizzyShopifyPageIdsCache[key] = ids;
    return ids;
  } catch (err) {
    console.error('Wizzy collection page fetch failed:', err);
    return [];
  }
}

function getShopifyCollectionBoostIds(handle, page, productsCount) {
  var currentPageIds = getShopifyCollectionPageIds(handle, page, productsCount);
  var nextPageIds = getShopifyCollectionPageIds(handle, page + 1, productsCount);
  return currentPageIds.concat(nextPageIds);
}

function prefetchShopifyCollectionPageIds(handle, page, productsCount) {
  if (!handle) return;
  var key = shopifyCollectionPageCacheKey(handle, page, productsCount);
  if (wizzyShopifyPageIdsCache[key]) return;

  fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=' + encodeURIComponent(productsCount) + '&page=' + encodeURIComponent(page))
    .then(function (res) {
      if (!res.ok) throw new Error('Collection page fetch failed');
      return res.json();
    })
    .then(function (json) {
      wizzyShopifyPageIdsCache[key] = (json.products || []).map(function (product) { return product.id; });
    })
    .catch(function (err) {
      console.error('Wizzy collection page prefetch failed:', err);
    });
}

function prefetchShopifyCollectionBoostIds(handle, page, productsCount) {
  prefetchShopifyCollectionPageIds(handle, page, productsCount);
  prefetchShopifyCollectionPageIds(handle, page + 1, productsCount);
}

function areStringArraysEqual(a = [], b = []) {
  if (a.length !== b.length) return false;

  const setA = new Set(a);
  for (const val of b) {
    if (!setA.has(val)) return false;
  }
  return true;
}

function arePriceRangesEqual(a = [], b = []) {
  if (a.length !== b.length) return false;

  const normalize = arr =>
    arr
      .map(r => `${r.gte ?? ''}-${r.lte ?? ''}`)
      .sort();

  const na = normalize(a);
  const nb = normalize(b);

  return na.every((v, i) => v === nb[i]);
}

function areAttributesEqual(a = {}, b = {}) {
  const keysA = Object.keys(a);
  const keysB = Object.keys(b);

  if (keysA.length !== keysB.length) return false;

  for (const key of keysA) {
    if (!Array.isArray(b[key])) return false;

    const arrA = a[key];
    const arrB = b[key];

    if (arrA.length !== arrB.length) return false;

    const setA = new Set(arrA);
    for (const val of arrB) {
      if (!setA.has(val)) return false;
    }
  }

  return true;
}

function normalizeRange(range) {
  return JSON.stringify({
    gte: Number(range.gte),
    lte: Number(range.lte)
  });
}

function areRangeArraysEqual(arrA = [], arrB = []) {
  if (arrA.length !== arrB.length) return false;

  const normA = arrA.map(normalizeRange).sort();
  const normB = arrB.map(normalizeRange).sort();

  for (let i = 0; i < normA.length; i++) {
    if (normA[i] !== normB[i]) return false;
  }

  return true;
}

function areFloatAttributesEqual(a = {}, b = {}) {
  const keysA = Object.keys(a);
  const keysB = Object.keys(b);

  if (keysA.length !== keysB.length) return false;

  for (const key of keysA) {
    if (!Array.isArray(b[key])) return false;

    if (!areRangeArraysEqual(a[key], b[key])) return false;
  }

  return true;
}

function hasFilterStateChanged(currentFilters) {
  if (!wizzyCachedFilters) return true;

  if (!areAttributesEqual(
    currentFilters.attributes || {},
    wizzyCachedFilters.attributes
  )) return true;

  if (!areFloatAttributesEqual(
    currentFilters.floatAttributes || {},
    wizzyCachedFilters.floatAttributes
  )) return true;

  if (!areStringArraysEqual(
    currentFilters.brands || [],
    wizzyCachedFilters.brands
  )) return true;

  if (!arePriceRangesEqual(
    currentFilters.sellingPrice || [],
    wizzyCachedFilters.sellingPrice
  )) return true;

  if (!areStringArraysEqual(
    currentFilters.genders || [],
    wizzyCachedFilters.genders
  )) return true;

  if (!areStringArraysEqual(
    currentFilters.sizes || [],
    wizzyCachedFilters.sizes
  )) return true;

  return false;
}

function deepClone(obj) {
  if (typeof structuredClone === "function") {
    return structuredClone(obj);
  }
  return JSON.parse(JSON.stringify(obj));
}

function getSessionNumber(key, defaultValue = 0) {
  const val = sessionStorage.getItem(key);
  return val !== null ? Number(val) : defaultValue;
}

function setSessionNumber(key, value) {
  sessionStorage.setItem(key, String(value));
}

function getSessionString(key, defaultValue = null) {
  const val = sessionStorage.getItem(key);
  return val !== null ? val : defaultValue;
}

function setSessionString(key, value) {
  if (value === null || value === undefined) {
    sessionStorage.removeItem(key);
  } else {
    sessionStorage.setItem(key, String(value));
  }
}

function setCachedFilters(filters) {
  sessionStorage.setItem(
    "wizzyCachedFilters",
    JSON.stringify(filters)
  );
}

function getCachedFilters() {
  try {
    return JSON.parse(
      sessionStorage.getItem("wizzyCachedFilters")
    ) || null;
  } catch {
    return null;
  }
}

function getSessionStringArray(key, defaultValue = []) {
  try {
    const val = sessionStorage.getItem(key);
    return val ? JSON.parse(val) : defaultValue;
  } catch {
    return defaultValue;
  }
}

function setSessionStringArray(key, array) {
  try {
    if (!Array.isArray(array)) return;
    sessionStorage.setItem(key, JSON.stringify(array));
  } catch {
    // silently ignore
  }
}
// Boosting Collection Pages Sort Order Code Ends